import React from 'react';

import WsIconProps from './IconProps';

const JobOutline: React.FC<WsIconProps> = ({ color = '#7E84AA', width = 14, height = 12 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6667 2H9.66671V1.33333C9.66671 0.979711 9.52623 0.640573 9.27618 0.390524C9.02613 0.140476 8.687 0 8.33337 0H5.66671C5.31309 0 4.97395 0.140476 4.7239 0.390524C4.47385 0.640573 4.33337 0.979711 4.33337 1.33333V2H2.33337C1.80294 2 1.29423 2.21071 0.919161 2.58579C0.544088 2.96086 0.333374 3.46957 0.333374 4V10C0.333374 10.5304 0.544088 11.0391 0.919161 11.4142C1.29423 11.7893 1.80294 12 2.33337 12H11.6667C12.1971 12 12.7058 11.7893 13.0809 11.4142C13.456 11.0391 13.6667 10.5304 13.6667 10V4C13.6667 3.46957 13.456 2.96086 13.0809 2.58579C12.7058 2.21071 12.1971 2 11.6667 2ZM5.66671 1.33333H8.33337V2H5.66671V1.33333ZM12.3334 10C12.3334 10.1768 12.2631 10.3464 12.1381 10.4714C12.0131 10.5964 11.8435 10.6667 11.6667 10.6667H2.33337C2.15656 10.6667 1.98699 10.5964 1.86197 10.4714C1.73695 10.3464 1.66671 10.1768 1.66671 10V6.26L4.78671 7.33333C4.85749 7.34294 4.92925 7.34294 5.00004 7.33333H9.00004C9.07234 7.332 9.14411 7.32078 9.21337 7.3L12.3334 6.26V10ZM12.3334 4.85333L8.89337 6H5.10671L1.66671 4.85333V4C1.66671 3.82319 1.73695 3.65362 1.86197 3.5286C1.98699 3.40357 2.15656 3.33333 2.33337 3.33333H11.6667C11.8435 3.33333 12.0131 3.40357 12.1381 3.5286C12.2631 3.65362 12.3334 3.82319 12.3334 4V4.85333Z"
      fill={color}
    />
  </svg>
);

export default JobOutline;
